import Status from 'clarks/components/ivu-table/status'

let forms = {
   filter_vouchers: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "datepicker", form_type: "daterange", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-md-6 col-lg-5 col-xl-4", validation: "required", placeholder: "Filter Vouchers by Date", model: "date", label: "Date",hide_label: true },
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-lg-2', model: 'submit', label: 'Search'}
      ]
   },
}

let tables = {
   vouchers: {
      props: {
         icon: 'fa fa-address-card',
         title: 'Vouchers',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['email', 'phone_number', 'total_amount', 'payment_channel', 'payment_data.receipt_number', 'paid_at', 'cards', 'names', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Receipt Number", slot: "receipt_number", align: 'center', width: 150 },
            { title: "Names", key: "names", minWidth: 250},
            { title: "Phone Number", slot: "phone_number", align: 'center', width: 200},
            { title: "Email", key: "email", minWidth: 250},
            { title: "Total Amount", slot: "total_amount", width: 200, align: 'right' },
            { title: "Payment Channel", key: "payment_channel",align: 'center', width: 200 },
            { title: "Paid At", slot: "paid_at", width: 200 },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Voucher Cards', event: 'vouchers:view_cards', icon: 'fa-gift', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}